<template>
  <div class="ReportInfo">
    <el-form :label-width="labelWidth">
      <el-form-item label="客户姓名">
        <p>{{info.customer_name}}</p>
      </el-form-item>
      <el-form-item label="手机号">
        <p>{{info.customer_phone}}</p>
      </el-form-item>
      <el-form-item label="经纪人">
        <p>{{info.realtor_name}}</p>
      </el-form-item>
      <el-form-item label="经纪人电话">
        <p>{{info.realtor_phone}}</p>
      </el-form-item>
      <el-form-item label="渠道类型">
        <p>{{info.realtor_role}}</p>
      </el-form-item>
      <el-form-item label="渠道公司">
        <p>{{info.realtor_company_name}}</p>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
  export default {
    name: 'ReportInfo',
    props: {
      info: {
        type: Object,
        default: {}
      },
    },
  }
</script>

<style lang="less" scoped>

</style>